import homeEn from '../../content/pages/home.en.json'
import homePl from '../../content/pages/home.pl.json'
import sportEn from '../../content/pages/sport.en.json'
import sportPl from '../../content/pages/sport.pl.json'
import servicesEn from '../../content/pages/services.en.json'
import servicesPl from '../../content/pages/services.pl.json'
import careerEn from '../../content/pages/career.en.json'
import careerPl from '../../content/pages/career.pl.json'
import contactEn from '../../content/pages/contact.en.json'
import contactPl from '../../content/pages/contact.pl.json'
import isoEn from '../../content/pages/iso.en.json'
import rosaEn from '../../content/pages/rosa.en.json'
import accessibilityStatementEn from '../../content/pages/accessibility-statement.en.json'

const LOCAL_PAGE_CONTENTS: Record<string, Record<string, any>> = {
  '/': { en: homeEn, pl: homePl },
  '/sport': { en: sportEn, pl: sportPl },
  '/services': { en: servicesEn, pl: servicesPl },
  '/career': { en: careerEn, pl: careerPl },
  '/contact': { en: contactEn, pl: contactPl },
  '/iso': { en: isoEn },
  '/rosa': { en: rosaEn },
  '/accessibility-statement': { en: accessibilityStatementEn },
}

const DIRECTUS_ASSETS_PREFIX = 'https://mamf-www-directus.moveapp.org/assets/'

/**
 * Normalizes asset URLs so that developers can simply pass:
 * "b72f3c96-200c-4e84-a6ae-00e4dd892611.webp" or "b72f3c96-200c-4e84-a6ae-00e4dd892611"
 * instead of the full https://mamf-www-directus.moveapp.org/assets/... URL.
 */
export const normalizeAssetUrls = (obj: any): any => {
  if (!obj || typeof obj !== 'object') return obj
  if (Array.isArray(obj)) return obj.map(normalizeAssetUrls)

  const result: Record<string, any> = {}
  for (const [key, val] of Object.entries(obj)) {
    if (key === 'url' && typeof val === 'string' && val.trim()) {
      const trimmed = val.trim()
      if (
        !trimmed.startsWith('http://') &&
        !trimmed.startsWith('https://') &&
        !trimmed.startsWith('/') &&
        !trimmed.startsWith('#') &&
        !trimmed.startsWith('mailto:') &&
        !trimmed.startsWith('tel:')
      ) {
        result[key] = `${DIRECTUS_ASSETS_PREFIX}${trimmed}`
      } else {
        result[key] = trimmed
      }
    } else if (typeof val === 'object' && val !== null) {
      result[key] = normalizeAssetUrls(val)
    } else {
      result[key] = val
    }
  }
  return result
}

/**
 * Returns page content.
 * Reads directly from local JSON files in `content/pages/` (localhost & UAT branch),
 * falling back to Directus CMS data if local file is missing.
 */
export const getPageContent = (
  slug: string,
  language: string = 'en',
  directusContentString?: string | null
): any => {
  const localPage = LOCAL_PAGE_CONTENTS[slug]
  if (localPage) {
    const localContent = localPage[language] || localPage['en']
    if (localContent) {
      return normalizeAssetUrls(localContent)
    }
  }

  if (directusContentString) {
    try {
      const parsed =
        typeof directusContentString === 'string'
          ? JSON.parse(directusContentString)
          : directusContentString
      return normalizeAssetUrls(parsed)
    } catch (e) {
      console.warn(`Failed to parse directus content for slug: ${slug}`, e)
    }
  }

  return {}
}

